module.exports = "/_next/static/files/b2b265cba1c380cb2cb42286c3555cb3.svg";